import { render, staticRenderFns } from "./crm-manage-companies-tab.vue?vue&type=template&id=316d3fd6&scoped=true&"
import script from "./crm-manage-companies-tab.vue?vue&type=script&lang=js&"
export * from "./crm-manage-companies-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d3fd6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VContainer,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316d3fd6')) {
      api.createRecord('316d3fd6', component.options)
    } else {
      api.reload('316d3fd6', component.options)
    }
    module.hot.accept("./crm-manage-companies-tab.vue?vue&type=template&id=316d3fd6&scoped=true&", function () {
      api.rerender('316d3fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/tabs/manage-companies/crm-manage-companies-tab.vue"
export default component.exports